import {popupUtil} from '@/helper/popup';
const PREFIX_RECEIVE_V1 = `https://img.phemex.com/v1/`;
import LegendQuestionnaireDialog from './LegendQuestionnaireDialog.svelte';
import LegendKYCStatus from './legend-kyc-status/LegendKYCStatus.svelte';
import RfiDialog from '@/modules/legend-trading/components/legend-questionnaire/legend-kyc-status/RfiDialog.svelte';

export const IMAGES = {
  ORDER_PROCESSING: `${PREFIX_RECEIVE_V1}86259d03-fd2e-4eb4-88c9-1dccdabe5315/order-processing.svg`,
  ORDER_TIME: `${PREFIX_RECEIVE_V1}af18cc67-cd06-4d93-9099-fbf57f311d4d/order-time.svg`,
  ORDER_FAILED: `${PREFIX_RECEIVE_V1}74f78ff5-f99d-42a5-b4f6-63e689dd119c/order-failed.svg`,
};

export async function openLegendQuestionnaire(options: {LG: any}): Promise<Boolean> {
  const dialog = popupUtil.create(LegendQuestionnaireDialog, options);
  return new Promise((resolve) => {
    dialog.$on('success', function (event) {
      dialog.$destroy();
      resolve(true);
    });
    dialog.$on('close', function () {
      dialog.$destroy();
      resolve(false);
    });
    dialog.$on('pending', function (event) {
      dialog.$destroy();
      const callback = event?.detail;
      if (callback) {
        callback(resolve);
      }
    });
  });
}

export async function openLegendKYCStatus(options: {LG: any; legendKycStatus: LEGEND_KYC_STATUS}): Promise<Boolean> {
  const dialog = popupUtil.create(LegendKYCStatus, options);
  return new Promise((resolve) => {
    dialog.$on('success', function (event) {
      dialog.$destroy();
      resolve(true);
    });
    dialog.$on('close', function () {
      dialog.$destroy();
      resolve(false);
    });
  });
}

export async function openLegendRfiStatus(options: {LG: any; url?: string; block?: boolean}): Promise<Boolean> {
  const dialog = popupUtil.create(RfiDialog, options);
  return new Promise((resolve) => {
    dialog.$on('success', function (event) {
      dialog.$destroy();
      resolve(true);
    });
    dialog.$on('close', function () {
      dialog.$destroy();
      resolve(false);
    });
  });
}

export const LEGEND_KYC_STATUS_DATA = {
  /** 需要填写问卷调查 */
  70050: 'WRITE_QUESTIONNAIRE',
  /** kyc审核中 */
  70051: 'IN_REVIEW',
  /** kyc审核拒绝 */
  70052: 'REJECTED',
  /** 刚提交问卷调查：需要轮询数据，只有在初次填写问卷调查的时候才会出现 */
  PROCESSING: 'PROCESSING',
  70053: 'EDD',
  70054: 'RFI',
  70055: 'RFI_BLOCK',
} as const;

export type LEGEND_KYC_STATUS = typeof LEGEND_KYC_STATUS_DATA[keyof typeof LEGEND_KYC_STATUS_DATA];
